import {Component, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {
  SubscriptionSelectorComponent
} from "../../../shared-module/components/subscription-selector/subscription-selector.component";
import {ButtonComponent} from "../../../shared-module/components/button/button.component";

import {NotFoundComponent} from "../../../shared-module/components/not-found/not-found.component";
import {ProductListComponent} from "../../../shared-module/components/product-list/product-list.component";
import {RouterLink} from "@angular/router";
import Product from "../../../shared-module/model/product.model";
import {Observable} from "rxjs";
import {ModalEventType} from "../../../shared-module/types/modal.type";
import ModalService from "../../../shared-module/services/modal.service";
import {AuthService} from "../../../shared-module/services/auth.service";
import {ProductOrderModalComponent} from "../../components/product-order-modal/product-order-modal.component";
import {ProductState} from "../../../shared-module/enums/product-state";
import Subscription from "../../../shared-module/model/subscription.model";
import {ModalEventTypes} from "../../../shared-module/enums/modal.event";
import Relation from "../../../shared-module/model/relation.model";

@Component({
    selector: 'app-order-product-page',
    imports: [
    SubscriptionSelectorComponent,
    ButtonComponent,
    NotFoundComponent,
    ProductListComponent,
    RouterLink
],
    templateUrl: './order-product-page.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './order-product-page.component.scss'
})
export class OrderProductPageComponent implements OnInit {
  private readonly modalService: ModalService = inject(ModalService);
  protected readonly authService: AuthService = inject(AuthService);

  public products: Product[] = [];
  public subscriptionItems: Subscription[] = [];
  private modalOrderSubscription: Observable<ModalEventType> | null = null;

  public ngOnInit(): void {
    this.loadProducts();

    this.authService.getActiveRelation().subscribe((relation: Relation | null): void => {
      if (!relation || !relation.subscriptions) {
        return;
      }
      this.subscriptionItems = relation.subscriptions;
    });

    this.authService.getSelectedSubscription().subscribe((subscription: Subscription | null): void => {
      this.setProductsForSubscription(subscription);
    });
  }

  public setProductsForSubscription(subscription: Subscription | null) {
    this.products = subscription?.available_products ?? [];
    if (Array.isArray(subscription?.products)) {
      const filteredProducts: Product[] | undefined = subscription?.products.filter((product: Product) => product?.state === ProductState.PENDING);
      this.products = [...this.products, ...filteredProducts];
    }
  }

  public order(product: Product): void {
    const modal: typeof ProductOrderModalComponent = ProductOrderModalComponent;

    if (!modal) {
      return;
    }

    if (this.modalOrderSubscription) {
      this.modalService.close();
    }

    this.modalOrderSubscription = this.modalService.open(modal, product, {
      width: '800px',
      showCloseButton: true,
      showBackdrop: true,
      title: product.specs.title,
      badgeIcon: product.specs.icon
    });

    this.modalOrderSubscription.subscribe((event: ModalEventType) => {
      if (event.type === ModalEventTypes.Confirmed) {
        product.state = ProductState.PENDING;
        this.loadProducts();
      }
    });
  }

  public loadProducts(): void {
    this.authService.getUser(['relations.subscriptions.products.discount_lines']).subscribe();
  }
}
